<template>
  <div
    :style="{ marginLeft: level * 16 + 'px' }"
  >
    <div
      v-for="(item, index) in conditions"
      :key="index"
    >
      <template v-if="Array.isArray(item)">
        <segement-conditions
          :conditions="item"
          :level="level + 1"
        />
      </template>
      <template v-else>
        <q-chip
          :class="{ 'text-bold': level <= 1 }"
          :square="level === 0"
          class="q-mr-xs"
        >
          {{ item }}
        </q-chip>
      </template>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SegementConditions',
  components: {
    'segement-conditions': () => import('src/modules/admin/customerio/SegmentConditions')
  },
  props: {
    conditions: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      required: false,
      default: 0
    }
  }
}
</script>
